<script setup>
import { useRouter } from 'vue-router';
import { Fold, Expand, BellFilled, ArrowDown, ArrowRight } from '@element-plus/icons-vue';
import { ElMessage, ClickOutside as vClickOutside } from 'element-plus';
import { computed, onMounted, ref, unref, inject, watch } from 'vue';
import { useStore } from 'vuex';
import { require, formatDateTime } from '@/utils/index';
import { getFontMsgApi, getReadHistory } from '@/apis/common';
import { Vue3Marquee } from 'vue3-marquee';
import Breadcrumb from '@/layout/Breadcrumb.vue';
import language from '@/components/center/language.vue';
import profile_avatar from '@/assets/images/center/profile_avatar.png';
import profile_hat from '@/assets/images/festival/hat.png';
import profile_a from '@/assets/image/level/a.jpg';
import profile_b from '@/assets/image/level/b.jpg';
import profile_c from '@/assets/image/level/c.jpg';
import { readContent } from '@/apis/common'

const langrage = inject('langrage');
const router = useRouter();
const store = useStore();
const sidebarOpen = computed(() => store.state.sidebarOpen);
const userInfo = computed(() => store.state.user.userInfo);
const currentUser = computed(() => userInfo.value?.user || {});
const userMessage = computed(() =>
    store.state.user.userMessage
)
const drawerVisible = ref(false)
const unreadCount = computed(() =>
    (userMessage.value || []).filter(item => item.isRead == 2).length
)
const badge = computed(() => unreadCount.value || '')
const readHistoryList = ref([])
const isHistoryMode = ref(false)//判断当前展示最新消息还是历史消息
const historyLoading = ref(false)
const displayedMessages = computed(() =>
    isHistoryMode.value ? readHistoryList.value : (userMessage.value || [])
)

watch(unreadCount, (count) => {
    drawerVisible.value = count > 0
}, { immediate: true })
const fontMsg = ref({});
const fontFamily = ref('');
const lang = localStorage.getItem('langrage');

// 活动相关
const isActivity = computed(() => store.getters.isActivity);
const handleCommand = (command) => {
    ElMessage(`click on item ${command}`);
};

const changeSidebar = () => {
    store.commit('TOGGLE_SIDEBAR');
};

const jumpPage = (path) => {
    router.push(path);
    // setTimeout(() => {
    //     location.reload();
    // }, 100);
};

// 获取公告信息
const getFontMsg = async () => {
    try {
        const { data, code, msg } = await getFontMsgApi();
        fontMsg.value = data;
        fontFamily.value = `'Be Vietnam Pro', 'source-han-sans', sans-serif`;
    } catch (error) {
        console.error(error);
    }
};

// 获取历史消息
const toggleMessageHistory = async () => {
    if (isHistoryMode.value) {
        isHistoryMode.value = false;
        return;
    }

    const userId = currentUser.value.userId;
    if (!userId || historyLoading.value) return;

    historyLoading.value = true;
    try {
        const { data } = await getReadHistory({ userId });
        readHistoryList.value = Array.isArray(data) ? data : [];
        isHistoryMode.value = true;
    } catch (error) {
        console.error(error);
    } finally {
        historyLoading.value = false;
    }
}

// 修改打开消息面板的方法
const openMessageDrawer = () => {
    isHistoryMode.value = false;
    drawerVisible.value = true;
}

// 修改关闭消息面板的方法
const closeMessageDrawer = () => {
    isHistoryMode.value = false;
    drawerVisible.value = false
}

const handleDrawerBeforeClose = (done) => {
    if (unreadCount.value === 0) {
        done()
    }
}

const changeType = async (item) => {
    let Timer = null

    if (item.isRead == 2) {
        //先前端改变状态,让使用变得丝滑
        store.commit('user/CHANGE_MESSAGE_TYPE', item.id)
        //然后找到传来的id,调接口把未读变为已读
        await readContent({ userId: currentUser.value.userId, id: item.id })
        //要做个防抖,我们只更新最后一次的消息数据,防止点了未读马上调接口回头影响其他数据
        if (Timer) {
            clearTimeout(Timer)
        }
        Timer = setTimeout(async () => {
            //获取铃铛信息
            await store.dispatch('user/getRemindContent');
        }, 500)
    } else if (!item) {
        //如果传的是空就是一键已读,调接口
        await readContent({ userId: currentUser.value.userId, id: null })
        //获取铃铛信息
        await store.dispatch('user/getRemindContent');
    }
}
const goMessage = () => {
    router.push('/account/profile');
};
const checkIn = async () => {
    //localStorage.clear();
    await store.dispatch('user/logout');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token');
    window.location.reload();
};

onMounted(() => {
    getFontMsg();
    const dropDownTrigger = document.getElementById('popover')

    dropDownTrigger.addEventListener('mouseenter', () => {
        // 移除鼠标悬停自动显示逻辑
    });
    dropDownTrigger.addEventListener('mouseleave', () => {
        // 移除鼠标离开自动隐藏逻辑
    });
});



</script>

<template>
    <div class="navbar">
        <div class="left flex-center">
            <div class="icon" @click="changeSidebar">
                <img :style="{
                    transform: sidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }" src="@/assets/images/center/menuFold.png" alt="" />
            </div>
            <div class="bread-crumb">
                <Breadcrumb />
            </div>
        </div>
        <div v-if="!isActivity" class="tips" style="font-size: 1.4rem;">
            <Vue3Marquee :duration="lang == 'chinese' ? fontMsg.flowSecond : fontMsg.flowSecond2" :pauseOnHover="true">
                <span v-if="lang == 'chinese'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">
               {{
                   fontMsg.valueInfo
               }}
                    </span>
                <span v-if="lang == 'english'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo2
                    }}</span>
            </Vue3Marquee>
        </div>
        <div class="right flex-center">
            <div class="user-info flex-center">
                <el-dropdown class="flex-center" trigger="click">
                   <div class="avatar-group">
                       <img class="avatar" :src="profile_avatar" alt="" />
                        <!-- <img class="avatar-hat" :src="profile_hat" alt="" /> -->
                   </div>
                   
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item command="zh" @click="goMessage">{{ langrage['profile1']
                                }}</el-dropdown-item>
                            <el-dropdown-item command="es" @click="checkIn">{{ langrage['navbar4'] }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <span @click="jumpPage('/account/profile')">{{ currentUser.userName || '' }}</span>
            </div>
         
            <!-- el-drawer 抽屉组件 -->
            <el-drawer v-model="drawerVisible" direction="rtl" size="360px" :with-header="false"
                :before-close="handleDrawerBeforeClose"
                custom-class="message-drawer">
                <div class="drawer-header">
                    <img src="@/assets/images/center/notice.png" alt="Notice" class="header-icon" />
                    <div class="header-info">
                        <span class="header-title">{{ langrage['dashboard31'] }}</span>
                        <span class="header-user">{{ currentUser.userName || '' }}</span>
                    </div>
                    <!-- 历史消息 -->
                    <div class="history-title" @click="toggleMessageHistory">
                        {{ isHistoryMode ? langrage['dashboard54'] : langrage['dashboard53'] }}
                    </div>
                </div>

                <!-- 分割线 -->
                <div class="divider"></div>

                <div class="popover_content" v-loading="historyLoading">
                    <div v-if="!isHistoryMode && userMessage.length" style="text-align: right; margin: 0" class="popover_botton_content">
                        <el-button size="small" @click="closeMessageDrawer">
                            {{ langrage['dashboard37'] }}
                        </el-button>
                        <el-button size="small" @click="changeType('')" color="#2b6bff" type="primary" class="">
                            {{ langrage['dashboard32'] }}
                        </el-button>
                    </div>
                    <!-- <p v-if="userMessage.length" class="popover_title" style="text-align: center;margin: 0;">
                        {{ langrage['dashboard31'] }}
                    </p> -->
                    <div class="popover_tip_content" v-if="displayedMessages.length">
                        <div class="popover_text_content" v-for="(item, index) in displayedMessages"
                            :key="item.id || index">
                            <div class="num_content">
                                <p class="num">{{ index + 1 }}.</p>
                                <p v-if="lang == 'english'" class="popover_text">
                                    {{ item.pushInfoEn }}
                                </p>
                                <p v-else class="popover_text">
                                    {{ item.pushInfo }}
                                </p>
                            </div>
                            <div class="bottom_content">
                                <div class="popover_time">
                                    {{ formatDateTime(item.updateTime || item.createTime) }}
                                </div>
                                <div v-if="lang === 'chinese'" class="popover_type"
                                    @click="!isHistoryMode && changeType(item)"
                                    :class="{ blue: item.isRead == 2, disabled: isHistoryMode }">
                                    {{ item.isRead == 2 ? langrage['dashboard36'] : langrage['dashboard35'] }}
                                </div>
                                <div v-else class="popover_type small-font"
                                    @click="!isHistoryMode && changeType(item)"
                                    :class="{ blue: item.isRead == 2, disabled: isHistoryMode }">
                                    {{ item.isRead == 2 ? langrage['dashboard36'] : langrage['dashboard35'] }}
                                </div>
                            </div>
                        </div>
                    </div>
                     <div v-else class="popover_tip_content">
                         <div style="text-align: center;margin-top: 45vh; font-size: 1.6rem;">
                            {{ isHistoryMode ? langrage['dashboard42'] : langrage['dashboard38'] }}
                        </div>
                    </div>

                </div>
            </el-drawer>
            
            <!-- 消息 -->
            <div style="height: 100%;margin-left: 1rem;" id="popover" @click="openMessageDrawer">
                <el-badge class="badge" :value="badge" :max="99" :offset="[3, -1]">
                    <img v-if="!badge" :src="require('@/assets/images/center/notice.png')" ref="buttonRef" alt=""
                        style="cursor: pointer; width: 2rem" />
                    <img v-else :src="require('@/assets/images/center/notice.png')" ref="buttonRef" alt=""
                        style="cursor: pointer; width: 2rem" />
                </el-badge>
            </div>
            
            <div class="btn flex-center" @click="jumpPage('/rocketWallet/index')">
                <img class="icon" :src="require('@/assets/images/center/Wallet_balance.png')" alt="" />
                <span>{{ langrage['centerNav_t1'] }}${{ currentUser.walletBalance ?? 0 }}</span>
            </div>
            <div class="select flex-center">
                <language />
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.message-drawer {
    border-radius: 12px 0 0 12px !important;

    .el-drawer__body {
        padding: 0;
    }
}

// 新增标题区域样式
.drawer-header {
    display: flex;
    align-items: center;
    padding: 20px 10px;
    background-color: #fff;
    border-bottom: 1px solid #e9ecef;

    .header-icon {
        width: 20px;
        height: 24px;
        margin-right: 12px;
    }

    .header-info {
        flex: 1;
        display: flex;
        flex-direction: column;

        .header-title {
            font-size: 1.6rem;
            font-weight: 500;
            color: #333;
        }

        .header-user {
            font-size: 1.3rem;
            color: #666;
            margin-top: 4px;
        }
    }

    .history-title {
        font-size: 1.5rem;
        color: #2A5EFF;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          color: #000;
          transform: translateY(-1px);
        }
    }
}

// 分割线样式
.divider {
    height: 1px;
    background-color: #e9ecef;
    margin: 0;
}

// 消息内容区域样式
.popover_content {
  font-size: 1.6rem;

  .popover_title {
    margin-bottom: 1rem !important;
    font-size: 1.6rem;
  }

  .popover_tip_content {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding: 10px 0;
    box-sizing: border-box;
    
    // 隐藏滚动条但保持功能
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }

  .popover_text_content {
    display: flex;
    flex-direction: column;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    box-sizing: border-box;
    margin-bottom: 15px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
    
    &:last-child {
      margin-bottom: 0;
    }

    .num_content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      padding: 15px 20px 10px 20px;
      width: 100%;
      box-sizing: border-box;

      .num {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 2rem;
        height: 2rem;
        background-color: #2b6bff;
        color: white;
        border-radius: 50%;
        font-size: 1.2rem;
        font-weight: bold;
        margin: 0.2rem 15px 0.2rem 0;
      }

      .popover_text {
        flex: 1;
        margin: 0;
        text-align: justify;
        font-size: 1.4rem;
        line-height: 1.5;
        color: #606266;
        word-wrap: break-word;
        word-break: break-word;
      }
    }
    
    .bottom_content {
        margin: 1rem 3rem;
        display: flex;
        justify-content: space-between;
        
        .popover_type {
          align-self: flex-end;
          color: #909399;
          cursor: pointer;
          font-size: 1.3rem;
          transition: color 0.3s;
          
          &:hover {
            color: #2b6bff;
          }
          
          &.blue {
            color: #2b6bff;
          }

          &.disabled {
            cursor: default;
          }
        }
    }
  }

  .popover_botton_content {
    padding: 1rem 0 2rem 0;
    display: flex;
    justify-content: flex-end;

    .el-button {
      margin-left: 12px;
    }
  }
}

// otf-opentype
// ttf-truetype
@font-face {
    font-family: 'Custom1';
    src: url('@/assets/fonts/1.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom2';
    src: url('@/assets/fonts/2.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom3';
    src: url('@/assets/fonts/3.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom4';
    src: url('@/assets/fonts/4.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom5';
    src: url('@/assets/fonts/5.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom6';
    src: url('@/assets/fonts/6.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom7';
    src: url('@/assets/fonts/7.ttf') format('truetype');
}

@font-face {
    font-family: 'Custom8';
    src: url('@/assets/fonts/8.otf') format('opentype');
}

::v-deep {
    .el-breadcrumb {
        font-size: 1.4rem;
    }
}

.scroll {
    border: 1px solid red;
    width: 50rem;
    overflow: hidden;
}

.navbar {
    position: fixed;
    z-index: 9;
    width: -webkit-fill-available;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 6rem;
    background: #ffffff;
    box-shadow: inset 0rem -0.1rem 0rem 0rem #f0f0f0;
    box-sizing: border-box;
    padding: 0 2rem 0 0;

    .left {
        margin: 0 1rem;
        .icon {
            width: 4rem;
            height: 4rem;
            line-height: 5.4rem;
            text-align: center;
            cursor: pointer;

            img {
                width: 2rem;
                height: 2rem;
            }
        }

        .tips {
            font-weight: 400;
            font-size: 1.4rem;
            color: #333333;
            margin-left: 5rem;
        }
        
        .bread-crumb{
            min-width: 30rem;
        }
    }

    .right {
        .btn {
            cursor: pointer;
            min-width: 12.5rem;
            padding: 0 1rem;
            height: 3rem;
            background: #eff5ff;
            border-radius: 1rem;
            border: 0.1rem solid #2b6bff;
            font-weight: 400;
            font-size: 1.4rem;
            color: #2b6bff;
            margin-right: 1.5rem;

            .icon {
                width: 1.4rem;
                height: 1.3rem;
            }

            span {
                margin: 0 0.5rem 0 1rem;
                font-weight: 400;
                font-size: 1.4rem;
                color: #2b6bff;
                white-space: nowrap;
            }
        }

        .badge {
            margin: 0 2.5rem 0 1.5rem;
            cursor: pointer;
        }

        .user-info {
            cursor: pointer;

            span {
                font-weight: 500;
                font-size: 1.4rem;
                color: #333333;
                margin-left: 2rem;
            }
            .avatar-group{
                position: relative;
                outline: none;
            }
            .avatar-hat{
                position: absolute;
                top: -1rem;
                left: -0.1rem;
                height: 4rem;
                width: 4rem;
            }

            .avatar {
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
                margin-left: 2rem;
            }

            .avatar2 {
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
            }

            .avatar:focus-visible {
                outline: none;
            }
        }

        .select {
            cursor: pointer;

            .language-box {
                position: relative;
                top: auto;
                right: auto;
            }

            img {
                width: 3rem;
                height: 3rem;
            }

            .el-dropdown-link {
                font-weight: 400;
                font-size: 1.2rem;
                color: #333333;
            }

            .el-dropdown-link:focus-visible {
                outline: none;
            }
        }
    }
}

.el-dropdown-menu__item {
    font-size: 1.4rem;
}

.el-dropdown-menu__item:not(.is-disabled):focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
    color: #2b6bff;
}

// .is-text {
//     /*border: 1px solid #ccc !important;*/
// }

.flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.small-font {
    font-size: 10px !important;
}
// 响应式设计
@media (max-width: 768px) {
   .navbar {
       display: none;
   }
}
</style>
